/**
 * @deprecated Use `dateFormatter` from `@/lib/utils/date` (dateTimeFormat.ts).
 * AI-DEV: the lib version takes the day in Europe/Berlin, this one in the browser zone. Fine for instants
 * (`created_at`); a calendar date (local-midnight Date) goes through `formatDate` instead.
 */
const dateFormatter = (dateobject) => {
  try {
    var datetemp = dateobject.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    return datetemp;
  } catch (_error) {
    return '-';
  }
};

/**
 * @deprecated Use `timeFormatter` from `@/lib/utils/date` (dateTimeFormat.ts), a drop-in replacement.
 * AI-DEV: don't import this service in new code.
 */
const timeFormatter = (dateobject) => {
  try {
    var timetemp = dateobject.toLocaleTimeString('de-DE', {
      timeZone: 'Europe/Berlin',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
    });

    return timetemp;
  } catch (_error) {
    return '-';
  }
};

export { dateFormatter, timeFormatter };
